import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "licenceCheck"
const LicenceCheckIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22 4.994v6.273a2 2 0 0 0-2.414.319L15.5 15.672l-1.586-1.586a2 2 0 0 0-2.828 0l-.914.914H5v1h4.267a2 2 0 0 0 .319 2.414l.586.586H3.99C2.89 19 2 18.105 2 17.006V4.994C2 3.893 2.898 3 3.99 3h16.02C21.108 3 22 3.895 22 4.994ZM12 8V6h7v2h-7Zm0 2V9h4v1h-4ZM5.99 6c-.539 0-.99.444-.99.99v4.02c0 .539.444.99.99.99h4.02c.539 0 .99-.444.99-.99V6.99c0-.539-.444-.99-.99-.99H5.99Zm16.51 8.5L21 13l-5.5 5.5-3-3L11 17l4.5 4.5 7-7Z"
          />
        </svg>
      }
    </span>
  )
}
export default LicenceCheckIcon
